import { getOr, isNil, isEmpty } from 'lodash/fp'

import { Dropdown } from 'common-components'

export const Component = Dropdown

const HookComponent = (hoc) => {
  const WrappedInput = hoc ? (Dropdown) : Dropdown
  return function(props) {
    const { setValue, options, placeHolder, customOnChange } = props
    const value = getOr('', 'value', props.value)
    const disabled = isNil(props.disabled) ? isEmpty(props.options) : props.disabled
    const _onChange = (value, index) => {
      const indexToFind = isNil(placeHolder) ? index : index - 1
      const option = options[indexToFind]
      if (option) {
        const text = getOr('', 'text', option)
        setValue({
          ...option,
          text: getOr(text, 'defaultText', option),
        })
        if (customOnChange && typeof customOnChange === 'function') {
          customOnChange(option)
        }
      } else {
        setValue(undefined)
      }
    }

    return <WrappedInput {...props} value={value} onChange={_onChange} disabled={disabled} />
  }
}

export default HookComponent
